import React from 'react'

import Amex from '@/components/Icons/Amex'
import CreditCard from '@/components/Icons/CreditCard'
import Mastercard from '@/components/Icons/Mastercard'
import Visa from '@/components/Icons/Visa'

export const getCardLogoForBrand = (brand: string) => {
  switch (brand.toLowerCase()) {
    case 'visa':
      return <Visa />

    case 'mastercard':
      return <Mastercard />

    case 'amex':
      return <Amex />

    default:
      return <CreditCard />
  }
}
